import type { JSX } from "solid-js";

export function Panel(props: {
  title: string;
  href?: string;
  span?: string;
  children: JSX.Element;
  status?: "healthy" | "degraded" | "critical";
}) {
  const statusAccent = () => {
    switch (props.status) {
      case "critical": return "border-l-[var(--color-critical)]";
      case "degraded": return "border-l-[var(--color-warning)]";
      default: return "border-l-transparent";
    }
  };

  return (
    <section
      data-panel
      class={`panel-bezel scanline-overlay border-l-2 p-0 transition-all duration-300 ${statusAccent()} ${props.span ?? "col-span-4"}`}
    >
      <header class="panel-header flex items-center justify-between border-b border-[rgba(255,255,255,0.04)] px-4 py-2.5">
        <div class="flex items-center gap-2.5">
          <div class="h-1.5 w-1.5 rounded-full bg-[var(--color-info)] opacity-50 animate-beacon" />
          <h2 class="font-mono text-[10px] font-bold uppercase tracking-[0.15em] text-[var(--color-text-secondary)]">
            {props.title}
          </h2>
        </div>
        {props.href && (
          <a
            href={props.href}
            target="_blank"
            rel="noreferrer"
            class="font-mono text-[9px] uppercase tracking-wider text-[var(--color-info)] opacity-50 transition-opacity hover:opacity-100"
          >
            source ↗
          </a>
        )}
      </header>
      <div class="relative z-[2] px-4 py-3">
        {props.children}
      </div>
    </section>
  );
}
